import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
/* Views */
import CardlessWithdrawGenerateCode from '@/views/cards/cardlessWithdraw/GenerateCode'
import CardlessWithdrawMyCodes from '@/views/cards/cardlessWithdraw/MyCodes'
import CardsConsult from '@/views/cards/Consult'
import CardsCancel from '@/views/cards/Cancel'
import CardsTransferFlex from '@/views/cards/transfer/Flex'
import ChargeFlex from '@/views/cards/charge/Flex'
import ChargeMCX from '@/views/cards/charge/MCX'
import ChargeKamba from '@/views/cards/charge/Kamba'
import ChargeVirtual from '@/views/cards/charge/Virtual'
import CardsActivate from '@/views/cards/Activate'
import ChangePayment from '@/views/cards/ChangePayment'
import Block from '@/views/cards/Block'
import CardsLimits from '@/views/cards/Limits'
import AnticipatePayment from '@/views/cards/AnticipatePayment'
import RequestCardsList from '@/views/cards/request/RequestListTypes'
import RequestVirtualCard from '@/views/cards/request/VirtualCard'
import BatchfileConsultFlex from '@/views/cards/batchfile/consult/Flex'
import BatchfileConsultKamba from '@/views/cards/batchfile/consult/Kamba'
import BatchfileConsultMulticaixa from '@/views/cards/batchfile/consult/Multicaixa'
import BatchfileNewCharge from '@/views/cards/batchfile/NewCharge'
import CardsHistory from '@/views/cards/History'
import ThirdLevelMenu from '@/views/ThirdLevelMenu'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.CARDS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ***********************************************
*                CARDLESS_WITHDRAW               *
*********************************************** */
{
	path: routeList.CARDS_CARDLESS_WITHDRAW_PATH,
	name: routeList.CARDS_CARDLESS_WITHDRAW_NAME,
	props: true,
	component: ThirdLevelMenu
}, {
	path: routeList.CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_PATH,
	name: routeList.CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_NAME,
	props: true,
	component: CardlessWithdrawGenerateCode
}, {
	path: routeList.CARDS_CARDLESS_WITHDRAW_MY_CODES_PATH,
	name: routeList.CARDS_CARDLESS_WITHDRAW_MY_CODES_NAME,
	props: true,
	component: CardlessWithdrawMyCodes
},
/* ***********************************************
*                     MY CARDS                   *
*********************************************** */
{
	path: routeList.CARDS_CONSULT_PATH,
	name: routeList.CARDS_CONSULT_NAME,
	props: true,
	component: CardsConsult
},
{
	path: routeList.CARDS_CANCEL_PATH,
	name: routeList.CARDS_CANCEL_NAME,
	props: true,
	component: CardsCancel
},
{
	path: routeList.CARDS_CHANGE_PAYMENT_PATH,
	name: routeList.CARDS_CHANGE_PAYMENT_NAME,
	props: true,
	component: ChangePayment
},
{
	path: routeList.CARDS_ANTICIPATE_PAYMENT_PATH,
	name: routeList.CARDS_ANTICIPATE_PAYMENT_NAME,
	props: true,
	component: AnticipatePayment
},
{
	path: routeList.CARDS_BLOCK_PATH,
	name: routeList.CARDS_BLOCK_NAME,
	props: true,
	component: Block
},
{
	path: routeList.CARDS_LIMITS_PATH,
	name: routeList.CARDS_LIMITS_NAME,
	props: true,
	component: CardsLimits
},
{
    path: routeList.CARDS_ACTIVATE_PATH,
	name: routeList.CARDS_ACTIVATE_NAME,
	props: true,
	component: CardsActivate
},
/* ***********************************************
*                    TRANSFER                    *
*********************************************** */
{
	path: routeList.CARDS_TRANSFERS_FLEX_PATH,
	name: routeList.CARDS_TRANSFERS_FLEX_NAME,
	component: CardsTransferFlex
},
/* ***********************************************
*                      CHARGE                    *
*********************************************** */
{
	path: routeList.CARDS_CHARGE_DIRECT_KAMBA_PATH,
	name: routeList.CARDS_CHARGE_DIRECT_KAMBA_NAME,
	props: true,
	component: ChargeKamba
}, {
	path: routeList.CARDS_CHARGE_FLEX_PATH,
	name: routeList.CARDS_CHARGE_FLEX_NAME,
	props: true,
	component: ChargeFlex
}, {
	path: routeList.CARDS_CHARGE_MULTICAIXA_PATH,
	name: routeList.CARDS_CHARGE_MULTICAIXA_NAME,
	props: true,
	component: ChargeMCX
}, {
	path: routeList.CARDS_CHARGE_VIRTUAL_PATH,
	name: routeList.CARDS_CHARGE_VIRTUAL_NAME,
	props: true,
	component: ChargeVirtual
},
/* ***********************************************
*                      REQUEST                   *
*********************************************** */
{
	path: routeList.CARDS_REQUEST_PATH,
	name: routeList.CARDS_REQUEST_NAME,
	props: true,
	component: RequestCardsList
},
{
	path: routeList.CARDS_REQUEST_CARD_GENERIC_PATH,
	name: routeList.CARDS_REQUEST_CARD_GENERIC_NAME,
	props: true,
	component: UnderDevelopment,
    beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CARDS_REQUEST_NAME)
	}
},
{
	path: routeList.CARDS_REQUEST_CARD_CVISA_VIRT_PATH,
	name: routeList.CARDS_REQUEST_CARD_CVISA_VIRT_NAME,
	props: true,
	component: RequestVirtualCard,
    beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CARDS_REQUEST_NAME)
	}
},
/* ***********************************************
*                     BATCHFILE                  *
*********************************************** */
{
	path: routeList.CARDS_BATCHFILE_PATH,
	name: routeList.CARDS_BATCHFILE_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ****************** Consult ***************** */
{
	path: routeList.CARDS_BATCHFILE_CONSULT_FLEX_PATH,
	name: routeList.CARDS_BATCHFILE_CONSULT_FLEX_NAME,
	component: BatchfileConsultFlex
}, {
	path: routeList.CARDS_BATCHFILE_CONSULT_KAMBA_PATH,
	name: routeList.CARDS_BATCHFILE_CONSULT_KAMBA_NAME,
	component: BatchfileConsultKamba
}, {
	path: routeList.CARDS_BATCHFILE_CONSULT_MULTICAIXA_PATH,
	name: routeList.CARDS_BATCHFILE_CONSULT_MULTICAIXA_NAME,
	component: BatchfileConsultMulticaixa
},
/* ****************** New Charge ***************** */
{
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_NAME,
	component: ThirdLevelMenu
}, {
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_FLEX_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_FLEX_NAME,
	component: BatchfileNewCharge
}, {
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_KAMBA_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_KAMBA_NAME,
	component: BatchfileNewCharge
}, {
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA_NAME,
	component: BatchfileNewCharge
},
/* ***********************************************
*********************************************** */
{
    path: routeList.CARDS_HISTORY_PATH,
    name: routeList.CARDS_HISTORY_NAME,
    props: true,
    component: CardsHistory
}]
